// オブジェクトの作成
var ISSEYMIYAKE = ISSEYMIYAKE || {}

/**
 * アプリwebview時の制御
 */
ISSEYMIYAKE['isApp'] = {
  check: () => {
    const userAgent = navigator.userAgent;
    const is_app = /iPhone|iPad|iPod|Android/i.test(userAgent) && userAgent.includes('Yappli');
    return is_app;
  },
  style: function() {
    if (this.check()) {
      document.addEventListener('DOMContentLoaded', () => {

        // bodyにクラス追加
        document.querySelector('body').classList.add('app');

        // 要素非表示
        const hide_elements = document.querySelectorAll('#shopify-section-header, #shopify-section-breadcrumb, #shopify-section-onlinestore-important-notice, .pagesOnlinestore-detail, .page_onlinestore_selector');
        hide_elements.forEach((element) => {
          element.style.display = 'none';
        });

        // mainタグの余白を0に
        document.querySelector('main').style.paddingTop = '0';
        
        // pickupアイテムの背景色変更
        document.querySelectorAll('._pickup_item')?.forEach((item) => {
          item.style.backgroundColor = '#fff';
          item.querySelector('h1').style.display = 'none';
          [...item.querySelectorAll('._more, ._close')].forEach(subItem => {
            subItem.style.backgroundColor = '#fff';
          });
        });
      });
    }
  }
}

/**
 * 記事検索部分のロジック
 */
ISSEYMIYAKE['articleSearch'] = {
  init: () => {
    const linkContainerItem = document.querySelectorAll('._linkContainer a._link')
    // クリックイベント発生で対応
    linkContainerItem.forEach(elm => {
      elm.addEventListener('click', e => ISSEYMIYAKE.articleSearch.clickEvt(e))
    });
  },
  clickEvt: (e) => {
    e.preventDefault()
    const searchResult = document.querySelector('#Search-In-Template')
    if (searchResult) {
      if (e.target.tagName == 'SPAN' || e.target.tagName == 'IMG') {
        window.location.href = e.target.closest('a').dataset.href + searchResult.value
      } else {
        window.location.href = e.target.closest('a').dataset.href + searchResult.value
      }
    }
  }
}

/**
 * GETパラメータ取得
 * @param {*} query 
 * @returns 
 */
ISSEYMIYAKE['getParams'] = (query) => {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {}
  
  for (let i = 0; i < query.length; i++) {
    if ( query[i] === 'filter.v.m.im-ft.vcolor' || query[i] === 'filter.p.vendor' || query[i] === 'filter.p.m.im-ft.item_category' ) {
      params[query[i]] = searchParams.getAll(query[i]).join(',')
    }
    else {
      params[query[i]] = searchParams.get(query[i])
    }
  }
  return params
}

/**
 * 配列の空確認
 * @param {*} obj 
 * @returns 
 */
ISSEYMIYAKE['isEmpty'] = (obj) => {
  let result = false
  for (let key in obj) {
    if (obj[key]) {
      result = true
      break
    }
  }
  return result
}

/**
 * セクションの更新（フェッチ）
 * @param {*} url 
 * @param {*} headers 
 * @returns 
 */
ISSEYMIYAKE['updateSections'] = (url, headers) => {
  return new Promise((resolve, reject) => {
    fetch(url, headers)
      .then(res => res.json())
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
}


ISSEYMIYAKE['JSONParse'] = (textContent) => {
  try {
    JSON.parse(textContent)
  } catch {
    console.error('予期せぬ値が含まれました')
    return false
  }
  return JSON.parse(textContent)
}

/**
 * セクション更新
 * @param {*} elm 
 * @param {*} target 
 */
ISSEYMIYAKE['ajaxUpdate'] = (elm, target) => {
  const parse = new DOMParser()
  const dom = parse.parseFromString(elm, 'text/html')
  document.querySelector(target).innerHTML = dom.querySelector(target).innerHTML
}

// /**
//  * ポイント部分の設定
//  */
// ISSEYMIYAKE['pointSettings'] = {
//   init: ($) => {
//     //TODO:radioボタンのsubmitが回避できずに送信されてしまう
//     $(document).on('click', '#clone_continue_button', (e) => ISSEYMIYAKE.pointSettings.clickEvt(e, $));
//   },
//   /**
//    * ポイント関連
//    */
//   clickEvt: async (e, $) => {
//     e.preventDefault();
//     ISSEYMIYAKE.pointSettings.initError();
//     const inputElement = document.querySelectorAll('.edit_checkout input[placeholder]')
//     let submit = false
//     for (let i = 0; i < inputElement.length; i++) {

//       submit = ISSEYMIYAKE.validation.fieldCheck(inputElement[i])

//       if (submit === false) {
//         break
//       }
//     }

//     ISSEYMIYAKE.validation.differentBillingAddressCheck()

//     if (submit == true) {
//       const pointCode = ISSEYMIYAKE.pointSettings.getPointCode();
//       document.querySelector('input[data-backup="phone"]').value = document.querySelector('input[data-backup="phone"]').value.replaceAll('-', '').trim()
//       // ポイント利用がない場合
//       if (!pointCode) {
//         document.getElementById('clone_continue_button').style.display = 'none'
//         document.getElementById('continue_button').style.display = 'block'
//         document.getElementById('continue_button').click()
//         return true;
//       }

//       // ポイント利用可能か確認
//       const message = await ISSEYMIYAKE.pointSettings.checkPointError(pointCode.toLowerCase());

//       if (message) {
//         ISSEYMIYAKE.pointSettings.displayError(message);
//       } else {
//         document.getElementById('clone_continue_button').style.display = 'none'
//         document.getElementById('continue_button').style.display = 'block'
//         document.getElementById("continue_button").click()
//         return true;
//       }
//     }


//   },
//   // ポイント利用ディスカウントコード取得
//   getPointCode: () => {
//     const discountCodes = document.querySelectorAll('.order-summary__section--discount .reduction-code__text');
//     let code = '';

//     for (let i = 0; i < discountCodes.length; i++) {
//       if (discountCodes[i].innerText.indexOf('POINT-') != -1) {
//         code = discountCodes[i].innerText;
//         break;
//       }
//     }

//     return code;
//   },
//   // ポイントチェック
//   checkPointError: async (pointCode) => {
//     const url = `${APP_PROXY_URL}/api/points/check`;
//     const params = {
//       pointCode
//     };

//     const res = await fetchPostMethod(url, params);

//     if (res.message === 'ok') {
//       if (!res.canUsePoint) {
//         return 'ポイント残高が不足しています、再度ショッピングバックよりポイントをご利用ください。';
//       }
//       return '';
//     } else {
//       return res.message;
//     }
//   },
//   // エラー表示タグ作成
//   createErrorTag: () => {
//     let footer = document.querySelector('.step__footer');
//     let errorTag = document.createElement('p');

//     errorTag.className = 'point_error';
//     errorTag.style.display = 'none';
//     footer.before(errorTag);
//   },
//   // エラー表示タグ初期化
//   initError: () => {
//     let errorTag = document.querySelector('.point_error');
//     errorTag.textContent = '';
//     errorTag.style.display = 'none';
//   },
//   // エラー表示
//   displayError: (message) => {
//     let errorTag = document.querySelector('.point_error');
//     errorTag.textContent = message;
//     errorTag.style.display = 'block';
//   }
// };


// /**
//  * バリデーション関連 Object
//  */
// ISSEYMIYAKE['validation'] = {
//   init: () => {
//     var isJapanPostalCodeLoaded = false;
//     window.addEventListener('load', () => {
//       if (!isJapanPostalCodeLoaded) {
//         if (Shopify.Checkout.step === 'contact_information') {
//           // 住所バリデーション
//           ISSEYMIYAKE.validation.shippingAddress()
//         }
//         if (Shopify.Checkout.step === 'payment_method') {
//           // 住所バリデーション
//           ISSEYMIYAKE.validation.billingAddress()

//           // 請求先の判定
//           ISSEYMIYAKE.validation.differentBillingAddressCheck()
//           const differentBillingAddress = document.querySelectorAll('input[name="checkout[different_billing_address]"]')
//           differentBillingAddress.forEach(elm => {
//             elm.addEventListener('change', (e) => ISSEYMIYAKE.validation.differentBillingAddressCheck())
//           })
//         }
//         isJapanPostalCodeLoaded = true;
//       }

//       const targetForm = document.querySelector('form.edit_checkout')
//       const inputElement = targetForm.querySelectorAll('input[placeholder]')
//       inputElement.forEach(elm => {
//         elm.addEventListener('change', e => ISSEYMIYAKE.validation.fieldCheck(e.target))
//       })

//       if (Shopify.Checkout.step === 'payment_method') {
//         const btn = document.querySelector('#continue_button')
//         const cloneBtn = document.createElement('button')
//         cloneBtn.setAttribute('type', 'button')
//         cloneBtn.setAttribute('id', 'clone_continue_button')
//         cloneBtn.setAttribute('class', btn.classList.value)
//         cloneBtn.setAttribute('aria-busy', false)
//         cloneBtn.innerHTML = btn.innerHTML
//         btn.after(cloneBtn)
//         btn.style.display = 'none'
//         btn.style.disabled = true
//       }
//     })
//   },
//   shippingAddress: () => {
//     // ZipCode AutoFill
//     if (typeof JapanPostalCode !== 'undefined') {
//       new JapanPostalCode(
//         {
//           container: '[data-step="contact_information"]',
//           country: '#checkout_shipping_address_country',
//           zipCode: '#checkout_shipping_address_zip',
//           city: '#checkout_shipping_address_city',
//           province: '#checkout_shipping_address_province',
//           address01: '#checkout_shipping_address_address1',
//           address02: '#checkout_shipping_address_address2',
//           firstName: '#checkout_shipping_address_first_name',
//           lastName: '#checkout_shipping_address_last_name',
//           firstNameKana: '#checkout_shipping_address_first_name_kana',
//           lastNameKana: '#checkout_shipping_address_last_name_kana',
//           phone: '#checkout_shipping_address_phone',
//           form: 'form.edit_checkout'
//         },
//         {
//           name: 'checkout',
//           messages: {
//             addressExists: "住所が正しくありません",
//             addressTownExists: "郵便番号に基づいた住所をご登録ください。ご入力いただいた住所の表記を再度ご確認ください。例）〇 三番町 × 3番町",
//           }
//         },
//       );
//     }
//   },
//   billingAddress: () => {
//     // ZipCode AutoFill for billing
//     if (typeof JapanPostalCode !== 'undefined') {
//       new JapanPostalCode(
//         {
//           container: '[data-step="contact_information"]',
//           country: '#checkout_billing_address_country',
//           zipCode: '#checkout_billing_address_zip',
//           city: '#checkout_billing_address_city',
//           province: '#checkout_billing_address_province',
//           address01: '#checkout_billing_address_address1',
//           address02: '#checkout_billing_address_address2',
//           firstName: '#checkout_billing_address_first_name',
//           lastName: '#checkout_billing_address_last_name',
//           firstNameKana: '#checkout_billing_address_first_name_kana',
//           lastNameKana: '#checkout_billing_address_last_name_kana',
//           phone: '#checkout_billing_address_phone',
//           form: 'form.edit_checkout'
//         },
//         {
//           name: 'checkout',
//           messages: {
//             addressExists: "住所が正しくありません",
//             addressTownExists: "郵便番号に基づいた住所をご登録ください。ご入力いただいた住所の表記を再度ご確認ください。例）〇 三番町 × 3番町",
//           }
//         },
//       );
//     }
//   },
//   differentBillingAddressCheck: () => {
//     const target = document.querySelector('#checkout_different_billing_address_true')
//     const lastName = document.querySelector('form > input[name="checkout[billing_address][last_name]"]')
//     const firstName = document.querySelector('form > input[name="checkout[billing_address][first_name]"]')
//     if (target.checked == true) {
//       lastName.disabled = false
//       firstName.disabled = false
//       return false
//     } else {
//       lastName.disabled = true
//       firstName.disabled = true
//       return true
//     }
//   },
//   fieldCheck: (target) => {
//     const fieldElement = target ? target.closest('div.field') : null
//     if (!fieldElement) {
//       return
//     }

//     if (target.getAttribute('name') === 'checkout[reduction_code]') return true
//     if (target.disabled === true) return true

//     const errorElement = fieldElement.querySelector('.field__message--error')
//     const regex = /^[\u30A0-\u30FF]+$/
//     if (errorElement) {
//       errorElement.remove()
//       fieldElement.classList.remove('field--error')
//     }

//     if (target.getAttribute('aria-required') === 'true' && target.value === '') {
//       ISSEYMIYAKE.validation.createError(target, 'を入力してください')
//       return false
//     }

//     if (
//       target.dataset.backup == 'first_name' && !target.value.match(/\S/g) ||
//       target.dataset.backup == 'last_name' && !target.value.match(/\S/g)
//     ) {
//       ISSEYMIYAKE.validation.createError(target, 'を入力してください')
//       return false
//     }

//     if (
//       target.dataset.backup == 'first_name_kana' && !regex.test(target.value) ||
//       target.dataset.backup == 'last_name_kana' && !regex.test(target.value)
//     ) {
//       ISSEYMIYAKE.validation.createError(target, 'はカタカナで入力してください')
//       return false
//     }
//     return true
//   },
//   createError: (target, text) => {
//     if (target.dataset.backup) {
//       const errorElement = document.createElement('p')
//       errorElement.setAttribute('class', 'field__message field__message--error error-message validation-error')
//       errorElement.setAttribute('id', `error-for-${target.dataset.backup}`)
//       errorElement.innerHTML = target.closest('div.field__input-wrapper').querySelector('label').innerHTML + text
//       target.closest('div.field__input-wrapper').after(errorElement)
//       target.closest('div.field').classList.add('field--error')
//     }
//   }
// }
// /**
//  * チェックアウト関連
//  */
// ISSEYMIYAKE['Checkout'] = {
//   /**
//    * 名前入力関連
//    * @param {*} step 
//    */
//   modifyNameFields: (step) => {
//     const targetForm = document.querySelector('form.edit_checkout[data-customer-information-form]') || document.querySelector('form.edit_checkout[data-payment-form]')
//     const lastName = document.querySelector('div[data-address-field="last_name"]')
//     const firstName = document.querySelector('div[data-address-field="first_name"]')
//     const country = document.querySelector('div[data-address-field="country"]')


//     // フリガナ用クローン作成
//     let lastNameKana = lastName.cloneNode(true)
//     let firstNameKana = lastName.cloneNode(true)

//     const kanaName = lastName.querySelector('input').value.split(' ')
//     const Name = firstName.querySelector('input').value.split(' ')

//     // フリガナ用のフィールドセット
//     if (!document.querySelector('#kana-name-fields')) {
//       firstNameKana = ISSEYMIYAKE.Checkout.cloneNameFields(firstNameKana, 'メイ', 'first_name_kana', kanaName[1] || '', step)
//       lastNameKana = ISSEYMIYAKE.Checkout.cloneNameFields(lastNameKana, 'セイ', 'last_name_kana', kanaName[0], step)
//     } else {
//       document.querySelector(`#checkout_${step}_address_first_name_kana`).value = kanaName[1] || ''
//       document.querySelector(`#checkout_${step}_address_last_name_kana`).value = kanaName[0] || ''
//       document.querySelector('#wl-name-kana').value = kanaName[0] + ' ' + kanaName[1] || ''
//     }

//     lastName.querySelector('input').value = Name[0] || ''
//     firstName.querySelector('input').value = Name[1] || ''

//     const nameElement = document.createElement('div')
//     nameElement.setAttribute('id', 'name-fields')
//     nameElement.setAttribute('class', 'clearfix')
//     nameElement.append(lastName)
//     nameElement.append(firstName)
//     country.after(nameElement)

//     if (!document.querySelector('#kana-name-fields')) {
//       const nameKanaElement = document.createElement('div')
//       nameKanaElement.setAttribute('id', 'kana-name-fields')
//       nameKanaElement.setAttribute('class', 'clearfix')
//       nameKanaElement.append(lastNameKana)
//       nameKanaElement.append(firstNameKana)
//       nameElement.after(nameKanaElement)
//     }



//     // POST用のクローン作成
//     const lastNameField = lastName.querySelector('input').cloneNode(true)
//     const firstNameField = firstName.querySelector('input').cloneNode(true)

//     // フォームに新たに氏名とフリガナ用のフィールド追加
//     ISSEYMIYAKE.Checkout.appendElement(targetForm, lastNameField, firstNameField)

//     // Name属性の削除
//     lastName.removeAttribute('name')
//     firstName.removeAttribute('name')

//     // 入力イベント
//     ISSEYMIYAKE.Checkout.nameInput(firstName, lastName, document.querySelector('#wl-name'))
//     ISSEYMIYAKE.Checkout.kanaNameInput(
//       document.querySelector('div[data-address-field="first_name_kana"]'),
//       document.querySelector('div[data-address-field="last_name_kana"]'),
//       document.querySelector('#wl-name-kana')
//     )

//   },
//   /**
//    * フリガナの入力フィールド作成
//    * @param {*} target 
//    * @param {*} label 
//    * @param {*} key 
//    * @param {*} value 
//    * @param {*} step 
//    * @returns 
//    */
//   cloneNameFields: (target, label, key, value, step) => {
//     target.dataset.addressField = key
//     const labelElement = target.querySelector('label')
//     const inputElement = target.querySelector('input')
//     const firstName = document.querySelector('div[data-address-field="first_name"]')

//     // labelの各属性調整
//     labelElement.innerHTML = label
//     labelElement.setAttribute('for', `checkout_${step}_address_${key}`)

//     // inputの各属性調整
//     inputElement.setAttribute('placeholder', label)
//     inputElement.setAttribute('data-backup', key)
//     inputElement.setAttribute('id', `checkout_${step}_address_${key}`)
//     //怪しいので除外
//     //inputElement.setAttribute('pattern', '[\uFF66-\uFF9F]*')
//     inputElement.removeAttribute('name')
//     inputElement.value = value

//     // 適用
//     firstName.after(target)
//     return target
//   },
//   /**
//    * 氏名の入力イベント
//    * @param {*} firstName 
//    * @param {*} lastName 
//    * @param {*} firstNameField 
//    */
//   nameInput: (firstName, lastName, firstNameField) => {
//     // 姓
//     ISSEYMIYAKE.Checkout.inputNameEvt(lastName.querySelector('input'), firstName, firstNameField, true)
//     lastName.addEventListener('input', (e) => ISSEYMIYAKE.Checkout.inputNameEvt(e.target, firstName, firstNameField, true))

//     // メイ
//     ISSEYMIYAKE.Checkout.inputNameEvt(firstName.querySelector('input'), lastName, firstNameField, false)
//     firstName.addEventListener('input', (e) => ISSEYMIYAKE.Checkout.inputNameEvt(e.target, lastName, firstNameField, false))
//   },
//   /**
//    * フリガナの入力イベント
//    * @param {*} firstNameKana 
//    * @param {*} lastNameKana 
//    * @param {*} lastNameField 
//    */
//   kanaNameInput: (firstNameKana, lastNameKana, lastNameField) => {
//     // フリガナ セイ
//     if (!document.querySelector('#wl-name')) {
//       ISSEYMIYAKE.Checkout.inputNameEvt(lastNameKana.querySelector('input'), firstNameKana, lastNameField, true)
//       ISSEYMIYAKE.Checkout.inputNameEvt(firstNameKana.querySelector('input'), lastNameKana, lastNameField, false)
//     } else {
//       ISSEYMIYAKE.Checkout.inputNameEvt(lastNameKana.querySelector('input'), firstNameKana, lastNameField, true)
//       ISSEYMIYAKE.Checkout.inputNameEvt(firstNameKana.querySelector('input'), lastNameKana, lastNameField, false)
//     }

//     lastNameKana.addEventListener('input', (e) => ISSEYMIYAKE.Checkout.inputNameEvt(e.target, firstNameKana, lastNameField, true))

//     // フリガナ メイ
//     firstNameKana.addEventListener('input', (e) => ISSEYMIYAKE.Checkout.inputNameEvt(e.target, lastNameKana, lastNameField, false))
//   },
//   /**
//    * 入力した際のイベントの内容
//    * @param {*} e 
//    * @param {*} otherName 
//    * @param {*} targetField 
//    * @param {*} prefix 
//    */
//   inputNameEvt: (e, otherName, targetField, prefix = true) => {
//     if (prefix === true) {
//       targetField.value = `${e.value.trim() || ''} ${otherName.querySelector('input').value.trim() || ''}`
//     } else {
//       targetField.value = `${otherName.querySelector('input').value.trim() || ''} ${e.value.trim() || ''}`
//     }
//   },
//   /**
//    * フォームにPOST用のフィールドを追加
//    * @param {*} targetForm 
//    * @param {*} lastNameField 
//    * @param {*} firstNameField 
//    */
//   appendElement: (targetForm, lastNameField, firstNameField) => {
//     lastNameField.removeAttribute('placeholder')
//     firstNameField.removeAttribute('placeholder')
//     firstNameField.setAttribute('id', 'wl-name')
//     lastNameField.setAttribute('id', 'wl-name-kana')

//     if (!document.querySelector('#wl-name')) {
//       targetForm.appendChild(lastNameField)
//       targetForm.appendChild(firstNameField)
//     }

//     lastNameField.setAttribute('type', 'hidden')
//     firstNameField.setAttribute('type', 'hidden')
//   }
// }

/**
 * 住所関連
 */
ISSEYMIYAKE['Addresses'] = {
  init: () => {
    const addressFormSubmit = document.querySelectorAll('.wl_edit_address .f-submit')
    const addressFormInput = document.querySelectorAll('.wl_edit_address input[data-name]')
    addressFormSubmit.forEach(btn => {
      btn.addEventListener('click', e => ISSEYMIYAKE.Addresses.clickEvt(e))
    })
    addressFormInput.forEach(input => {

      input.addEventListener('change', e => ISSEYMIYAKE.Addresses.changeEvt(e))
    })
  },
  /**
   * フィールドを更新した際の挙動
   * @param {Event} e 
   */
  changeEvt: (e) => {
    const fieldElement = e.target ? e.target.closest('div.field') : null
    let kanaName = false
    if (e.target.dataset.name == 'last_name_kana' || e.target.dataset.name == 'first_name_kana') {
      kanaName = true
    }
    ISSEYMIYAKE.Addresses.errorClear(e.target)
    ISSEYMIYAKE.Addresses.validationAddress(fieldElement, e.target, kanaName)
  },
  /**
   * クリックした際のイベント
   * @param {Event} e 
   * @returns 
   */
  clickEvt: (e) => {
    e.preventDefault()
    const target = e.target.closest('form.wl_edit_address')
    const targetField = {}
    targetField['lastName'] = target.querySelector('input[data-last_name]')
    targetField['firstName'] = target.querySelector('input[data-first_name]')
    targetField['lastNameKana'] = target.querySelector('input[data-last_name_kana]')
    targetField['firstNameKana'] = target.querySelector('input[data-first_name_kana]')

    let check = true
    check = ISSEYMIYAKE.Addresses.validator(targetField, check)

    if (check === false) {
      return false
    }

    target.querySelector('input[name="address[last_name]"]').value = `${targetField.lastNameKana.value} ${targetField.firstNameKana.value}`
    target.querySelector('input[name="address[first_name]"]').value = `${targetField.lastName.value} ${targetField.firstName.value}`
    target.submit()
  },
  /**
   * バリデーション
   * @param {*} fieldElement 
   * @param {*} target 
   * @param {*} kanaField 
   * @returns 
   */
  validationAddress: (fieldElement, target, kanaField = false) => {
    ISSEYMIYAKE.Addresses.errorClear(target)
    const regex = /^[\u30A0-\u30FF]+$/
    if (!target.value) {
      ISSEYMIYAKE.Addresses.createErrorElement(fieldElement, target, 'を入力してください')
      return false
    }
    if (
      kanaField == true && !regex.test(target.value) ||
      kanaField == true && !regex.test(target.value)
    ) {
      ISSEYMIYAKE.Addresses.createErrorElement(fieldElement, target, 'はカタカナで入力してください')
      return false
    }
    return true
  },
  /**
   * エラーの削除
   * @param {*} target 
   */
  errorClear: (target) => {
    target.classList.remove('error-field')
    const targetError = document.querySelector(`#error-for-${target.dataset.name}`)
    if (targetError) {
      targetError.remove()
    }
  },
  /**
   * エラーの作成
   * @param {*} fieldElement 
   * @param {*} target 
   * @param {*} text 
   */
  createErrorElement: (fieldElement, target, text) => {
    const errorElement = document.createElement('p')
    target.classList.add('error-field')
    errorElement.setAttribute('class', 'field__message field__message--error error-message validation-error')
    errorElement.setAttribute('id', `error-for-${target.dataset.name}`)
    errorElement.innerHTML = target.getAttribute('placeholder') + text
    fieldElement.querySelector('._namebox').after(errorElement)
    fieldElement.classList.add('field--error')
  },
  /**
   * バリデーションがクリアかの判定
   * @param {*} targetField 
   * @param {*} check 
   * @returns 
   */
  validator: (targetField, check) => {
    let result = false
    for (const [key, elm] of Object.entries(targetField)) {
      const fieldElement = elm ? elm.closest('div.field') : null
      if (!fieldElement) {
        return false
      }
      let kanaName = false
      if (key == 'lastNameKana' || key == 'firstNameKana') {
        kanaName = true
      }
      result = ISSEYMIYAKE.Addresses.validationAddress(fieldElement, elm, kanaName)
      if (result == false) {
        check = false
      }
    }
    return check
  }
}
/**
 * 検索関連
 */
ISSEYMIYAKE['Search'] = {
  init: () => {
    const targetForm = document.forms['search']
    const searchChangeBtn = document.querySelector('#search-change-btn')

    if (searchChangeBtn) {
      // ADA: Set href attribute with valid URL for screen readers and keyboard navigation
      searchChangeBtn.setAttribute('href', '#')
      searchChangeBtn.addEventListener('click', (e) => {
        ISSEYMIYAKE.Search.queryChangeEvt()
      })
    }
    if (targetForm) {
      targetForm.addEventListener('submit', (e) => ISSEYMIYAKE.Search.submitEvt(e))
    }
    ISSEYMIYAKE.Search.setQueryFields()
    ISSEYMIYAKE.Search.sortToggle()

  },
  /**
   * 検索内容の送信
   * @param {*} e 
   */
  submitEvt: (e) => {
    e.preventDefault()
    ISSEYMIYAKE.Search.setQuery(e.target)
    
    const data = ISSEYMIYAKE.Search.processFormData(new FormData(e.target))
    const params = new URLSearchParams(data);
    fetch(`/search?${params}`, {
      method: 'GET'
    })
    .then(response => {
      if (response.ok) {
        window.location.href = response.url;
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  },
  /**
   * dataから値が空白のものを削除し、カンマ区切りの値を分割してdataに追加する関数
   * @param {FormData} data - FormDataオブジェクト
   * @returns {FormData} - 空白の値が削除されたFormDataオブジェクト
   */
  processFormData: (originalData) => {
    const newData = new FormData();
    for (const [key, value] of originalData.entries()) {
      if (value !== '') {
        if (value.includes(',')) {
          const values = value.split(',');
          values.forEach((val) => {
            newData.append(key, val.trim());
          });
        } else {
          newData.append(key, value);
        }
      }
    }
    return newData;
  },
  /**
   * なしの場合にdisabled解除
   * @param {*} target 
   */
  setQuery: (target) => {
    for (let i = 0; i < target.elements['q'].length; i++) {
      if (target.elements['q'][i].value === '' && target.elements['q'][i].classList.contains('keyword')) {
        target.elements['q'][i].disabled = true
        document.querySelector('#all_search').disabled = false
      }
    }

  },
  /**
   * Build URL for search condition change (ADA: returns URL string for href attribute)
   * @returns {string} - Encoded search URL
   */
  buildSearchUrl: () => {
    const query = ['q', 'filter.p.vendor', 'filter.p.m.im-ft.item_category', 'filter.v.m.im-ft.vcolor', 'filter.v.price.gte', 'filter.v.price.lte', 'sort_by', 'filter.v.availability', 'filter.p.product_type']
    const params = ISSEYMIYAKE.getParams(query)

    document.dispatchEvent(new CustomEvent('open-search-panel', {
      detail: {
        keyword: params.q || '',
        brand: params['filter.p.vendor'] || '',
        item: params['filter.p.m.im-ft.item_category'] || '',
        color: params['filter.v.m.im-ft.vcolor'] || '',
        price1: params['filter.v.price.gte'] || '',
        price2: params['filter.v.price.lte'] || ''
      }
    }));

    return encodeURI(`/search?type=product&keyword=${params.q ? encodeURIComponent(params.q) : ''}&brand=${params['filter.p.vendor'] ? encodeURIComponent(params['filter.p.vendor']) : ''}&item=${params['filter.p.m.im-ft.item_category'] ? encodeURIComponent(params['filter.p.m.im-ft.item_category']) : ''}&color=${params['filter.v.m.im-ft.vcolor'] ? encodeURIComponent(params['filter.v.m.im-ft.vcolor']) : ''}&price_1=${params['filter.v.price.gte'] ? encodeURIComponent(params['filter.v.price.gte']) : ''}&price_2=${params['filter.v.price.lte'] ? encodeURIComponent(params['filter.v.price.lte']) : ''}&sort_by=${params['sort_by'] ? encodeURIComponent(params['sort_by']) : ''}&availability=${params['filter.v.availability'] ? encodeURIComponent(params['filter.v.availability']) : ''}&product_type=${params['filter.p.product_type'] ? encodeURIComponent(params['filter.p.product_type']) : ''}`);
  },
  /**
   * 検索条件の変更を押した際のリダイレクト
   */
  queryChangeEvt: () => {
    ISSEYMIYAKE.Search.buildSearchUrl();
  },
  /**
   * 検索フィールドのセット
   */
  setQueryFields: () => {
    const ecSearch = document.querySelector('.ec-search')
    const query = ['keyword', 'brand', 'item', 'color', 'price_1', 'price_2', 'sort_by', 'product_type']
    let params = ISSEYMIYAKE.getParams(query)
    const query2 = ['q', 'filter.p.vendor', 'filter.p.m.im-ft.item_category', 'filter.v.m.im-ft.vcolor', 'filter.v.price.gte', 'filter.v.price.lte', 'sort_by', 'filter.p.product_type', 'filter.v.availability' ]
    let params2 = ISSEYMIYAKE.getParams(query2)

    if (!ecSearch) {
      return false
    }
    if (params.keyword === null && params.brand === null && ecSearch.dataset.searchResults === '0') {
      params.keyword = params2['q']
      params.brand = params2['filter.p.vendor']
      params.item = params2['filter.p.m.im-ft.item_category']
      params.color = params2['filter.v.m.im-ft.vcolor']
      params.price_1 = params2['filter.v.price.gte']
      params.price_2 = params2['filter.v.price.lte']
      params.availability = params2['filter.v.availability']
      params.product_type = params2['filter.p.product_type']
    }
    Object.keys(params).forEach((query) => {
      let key = query
      if (query === 'keyword') key = 'q'
      if (query === 'brand') key = 'filter.p.vendor'
      if (query === 'item') key = 'filter.p.m.im-ft.item_category'
      if (query === 'color') key = 'filter.v.m.im-ft.vcolor'
      if (query === 'price_1') key = 'filter.v.price.gte'
      if (query === 'price_2') key = 'filter.v.price.lte'
      if (query === 'availability') key = 'filter.v.availability'
      if (query === 'product_type') key = 'filter.p.product_type'
      const target = document.querySelector('form[name="search"] input[name="' + key + '"]')

      if (target && params[query]) {
        target.value = params[query] == '*' ? '' : decodeURIComponent(params[query])
        if (target.closest('div').classList.contains('ec-search__optionswrap')) {
          ISSEYMIYAKE.Search.setOptions(target, params, query)
        }
      }
    })
  },
  /**
   * 検索オプションのラベルなどのセット
   * @param {*} target 
   * @param {*} params 
   * @param {*} query 
   */
  setOptions: (target, params, query) => {
    const options = target.closest('div').querySelectorAll('.js-option')
    const decodedValue = decodeURIComponent(params[query]);
    const decodedValuesArray = decodedValue.split(',');
    let active_label = [];

    options.forEach(option => {
      option.classList.remove('active');
      if ( decodedValuesArray.includes(option.dataset.value) )  {
        option.classList.add('active')
        active_label.push(`${option.dataset.label}`);
      }
    });

    let htmlLabels = active_label.map(label => {
      if (label.includes("<span")) {
        return label;
      } else {
        return `<span class="label">${label}</span>`;
      }
    }).join(',');
    
    target.closest('div').querySelector('.js-label').innerHTML = htmlLabels;
  },
  /**
   * ソートボタンのクリックイベント
   */
  sortToggle: () => {
    const btn = document.querySelector('._sortOpener')
    const menu = document.querySelector('._sortMenu')
    if (!btn) return false
    btn.addEventListener('click', e => {
      menu.classList.toggle('open')
      btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') == 'true' ? false : true)
    })
    ISSEYMIYAKE.Search.changeSort(btn)
    ISSEYMIYAKE.Search.changeAvailability(btn)
  },
  /**
   * ソートを変更した際の挙動
   */
  changeSort: (btn) => {
    const sort = document.querySelectorAll('input[name="sortState"]')
    sort.forEach((elm) => {
      elm.addEventListener('change', async (e) => {
        const target = document.querySelector('#product-grid')
        let urls = new URL(window.location.href);

        // URLSearchParamsオブジェクトを取得
        let params = urls.searchParams;

        params.set('sort_by', e.target.dataset.sort);
        history.pushState({}, '', '/search?' + params.toString())

        btn.querySelector('._select').innerHTML = e.target.dataset.id

        const url = `?sections[]=${target.dataset.id}&sections_url=${window.location.pathname}&${params.toString()}`
        const result = await ISSEYMIYAKE.updateSections(url, {})
        ISSEYMIYAKE.ajaxUpdate(result[target.dataset.id], '#product-grid')
        btn.click(true)
      })
    })
  },
  /**
   * 在庫有無のイベント
   */
  changeAvailability: (btn) => {
    const availability = document.querySelector('input[name="onlyInStock"]')
    const target = document.querySelector('#product-grid')

    availability.addEventListener('change', async (e) => {
      let urls = new URL(window.location.href)
      let params = urls.searchParams;

      params.set('filter.v.availability', e.target.checked ? '1' : '')
      history.pushState({}, '', '/search?' + params.toString())

      const url = `?sections[]=${target.dataset.id}&sections_url=${window.location.pathname}&${params.toString()}`
      const result = await ISSEYMIYAKE.updateSections(url, {})
      ISSEYMIYAKE.ajaxUpdate(result[target.dataset.id], '#product-grid')
      ISSEYMIYAKE.ajaxUpdate(result[target.dataset.id], '#storeitems_head')
      btn.click(true)
      ISSEYMIYAKE['Search'].init()
    })
  }
}

/**
 * 数量制限
 */
ISSEYMIYAKE['QuantityLimit'] = {
  init: async (updateQuantity, variantId, limitQuantity, limitVariantItem, targetHandle) => {
    // const items = await ISSEYMIYAKE.QuantityLimit.getCartItem(targetHandle)
    // const result = ISSEYMIYAKE.QuantityLimit.QuantityLimitCheck(items, updateQuantity, variantId, limitQuantity, limitVariantItem)
    const result = true
    return result
  },
  /**
   * ターゲットにした商品を取得
   * @param {*} targetHandle 
   * @returns 
   */
  getCartItem: (targetHandle) => {
    return new Promise((resolve, reject) => {
      fetch(Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(res => {
          const getItem = res?.items.filter(item => item.handle === targetHandle)
          resolve(getItem)
        })
        .then(error => reject(error))
    })
  },
  /**
   * 数量の確認
   * @param {*} items 
   * @param {*} updateQuantity 
   * @param {*} targetVariantId 
   * @param {*} limitQuantity 
   * @param {*} limitVariantItem 
   * @returns 
   */
  QuantityLimitCheck: (items = [], updateQuantity, targetVariantId, limitQuantity = 4, limitVariantItem = 2) => {
    updateQuantity = Number(updateQuantity)
    targetVariantId = Number(targetVariantId)

    const error = {
      error: true
    }

    let quantityCount = updateQuantity
    let variantQuantity = updateQuantity
    let upadateFlg = false
    let countOtherProduct = 0

    for (let key in items) {
      variantQuantity = updateQuantity
      if (items[key].variant_id != targetVariantId) {
        quantityCount += items[key].quantity
        countOtherProduct += items[key].quantity
      }

    }

    const variant = items.filter(e => e.variant_id === targetVariantId)
    let variQuantity = variant[0]?.quantity
    if (location.pathname.match(/\/cart/) && variant[0]?.quantity > updateQuantity) {
      variQuantity = variant[0]?.quantity - updateQuantity
    } else if (location.pathname.match(/\/cart/) && variant[0]?.quantity < updateQuantity) {
      variQuantity = updateQuantity
    } else {
      variQuantity = variant[0]?.quantity + updateQuantity
    }

    if (quantityCount > limitQuantity) {
      error['value'] = limitQuantity - countOtherProduct
      error['text'] = items[0]?.product_title + ' は購入できる数量が制限されています。'
      return error
    }

    // 商品数量が指定よりもオーバーした場合
    if ((countOtherProduct + variQuantity) > limitQuantity && !location.pathname.match(/\/cart/)) {
      error['value'] = limitQuantity - countOtherProduct
      error['text'] = variant[0]?.product_title + ' は購入できる数量が制限されています。'
      return error
    }

    // バリエーションの数量が指定よりもオーバーした場合
    if (variQuantity > limitVariantItem) {
      error['value'] = limitVariantItem
      error['text'] = variant[0]?.product_title + ' - ' + variant[0]?.variant_title + ' は購入できる数量が制限されています。'
      return error
    }

    if (quantityCount <= limitQuantity) {
      upadateFlg = true
    }
    return upadateFlg
  }
}

/**
 * カート関連
 */
ISSEYMIYAKE['Cart'] = {
  init: () => {
    ISSEYMIYAKE.Cart.shippingErrorObject()
    ISSEYMIYAKE.Cart.noteAttributesUpdate()
    // ISSEYMIYAKE.Cart.lineItemPoint()
  },
  shippingErrorObject: () => {
    const target = document.querySelector('#cart-delivery-datetime_section'); // body要素を監視
    const observer = new MutationObserver(function (mutations) {
      if (target.querySelector('.error-message')) {
        if (target.querySelector('.error-message').childNodes.length === 0) {
          target.querySelector('.error-message').classList.add('hidden')
        }
        if (target.querySelector('.error-message').childNodes.length !== 0) {
          target.querySelector('.error-message').classList.remove('hidden')
        }
      }
    });
    if (target) {
      // 監視を開始
      observer.observe(target, {
        childList: true, // 子ノードの変化を監視
        subtree: true // 子孫ノードも監視対象に含める
      });
    }
  },
  noteAttributesUpdate: () => {
    // TODO: note部分の修正
    const note = document.querySelector('.cart-price__notes[name="note"]')
    if (note) {
      note.addEventListener('change', (e) => {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'note': e.target.value
          })
        })
      })
    }
  },
  /**
   * カートページでのポイント利用関数
   */
  // lineItemPoint: () => {
  //   const lineItem = document.querySelectorAll('form > #main-cart-items .wl-line_item_point')
  //   const usePointElm = document.querySelector('.js-usepoint-text')
  //   const totalPriceElm = document.querySelector('.js-totalprice')
  //   const totalPointElm = document.querySelector('.js-total-point')
  //   const totalPointInputAll = document.querySelectorAll('input[name="attributes[_get_point]"]')
  //   const totalPointInput = document.querySelector('input[name="attributes[_get_point]"]')
  //   const usePoint = usePointElm.dataset.value || 0
  //   let totalPrice = totalPriceElm.dataset.value || 0

  //   const priceObject = ISSEYMIYAKE.Point.pointLogic(lineItem, totalPrice, usePoint, false) || {}

  //   // トータル獲得へ反映
  //   // wl20230302
  //   totalPointElm.innerHTML = Math.sign(priceObject?.totalAddPoint.toNumber()) == 1 ? Math.floor(priceObject?.totalAddPoint.toNumber()).toLocaleString() : 0
  //   // wl20230302
  //   //totalPointInput.value = Math.sign(priceObject?.totalAddPoint.toNumber()) == 1 ? Math.floor(priceObject?.totalAddPoint.toNumber()) : 0
  //   for (let i = 0; i < totalPointInputAll.length; i++) {
  //     totalPointInputAll[i].value = Math.sign(priceObject?.totalAddPoint.toNumber()) == 1 ? Math.floor(priceObject?.totalAddPoint.toNumber()) : 0
  //   }
  //   //fetch(Shopify.routes.root + `cart/update.js?attributes[_get_point]=${totalPointInput.value}`)
  // },

}

// /**
//  * ポイント計算ロジック
//  */
// ISSEYMIYAKE['Point'] = {
//   /**
//    * ポイント計算ロジック
//    * @param {Array} lineItem 
//    * @param {Number || String} totalPrice 
//    * @param {Number || String} usePoint 
//    * @param {Boolean} setLineItemPoint 
//    * @returns 
//    */
//   pointLogic(lineItem, totalPrice, usePoint, setLineItemPoint = false) {
//     let priceObject = {}
//     // 対象金額の算出
//     priceObject.totalPrice = ISSEYMIYAKE.Point.lineItemOnSale(lineItem, totalPrice)

//     // 対象の総額
//     priceObject = ISSEYMIYAKE.Point.lineItemTotalPrice(priceObject, usePoint)

//     // 商品単位での計算
//     priceObject = ISSEYMIYAKE.Point.setLineItemPoint(lineItem, priceObject, setLineItemPoint)

//     return priceObject
//   },
//   /**
//    * セールタグ・優待タグの判定
//    * @param {*} lineItem 
//    * @param {*} totalPrice 
//    * @returns 
//    */
//   lineItemOnSale(lineItem, totalPrice) {
//     totalPrice = new Decimal(totalPrice)
//     for (let i = 0; i < lineItem.length; i++) {
//       const price1 = lineItem[i].dataset.price
//       const saleTag1 = lineItem[i].dataset.saleTag
//       const preferentialTag1 = lineItem[i].dataset.preferentialTag
//       // saleタグがあった場合の処理
//       const p1 = new Decimal(price1)
//       const tax = new Decimal(1.1)
//       if (saleTag1 == 'true' && preferentialTag1 == 'false') {
//         totalPrice = new Decimal(totalPrice).minus(p1.times(tax))
//       }
//     }
//     return totalPrice.toNumber()
//   },
//   /**
//    * トータルのポイント対象金額を取得
//    * @param {*} priceObject 
//    * @param {*} usePoint 
//    * @returns 
//    */
//   lineItemTotalPrice(priceObject, usePoint) {
//     priceObject.subjectPrice = new Decimal(priceObject.totalPrice).minus(Number(usePoint))
//     priceObject.subjectPoint = (priceObject.subjectPrice.toNumber() / priceObject.totalPrice) * 100 / 100

//     return priceObject
//   },
//   /**
//    * 各商品に基づくポイントの取得/設定
//    * @param {*} lineItem 
//    * @param {*} priceObject 
//    * @param {*} setPoint 
//    * @returns 
//    */
//   setLineItemPoint(lineItem, priceObject, setPoint = false) {
//     let totalAddPoint = new Decimal(0)
//     // ループ
//     for (let i = 0; i < lineItem.length; i++) {
//       let addPoint = new Decimal(0)
//       const price = lineItem[i].dataset.price
//       const saleTag = lineItem[i].dataset.saleTag
//       const preferentialTag = lineItem[i].dataset.preferentialTag
//       const doublePointTag = lineItem[i].dataset.doublePointTag
//       const addPointPrice = new Decimal(price * priceObject.subjectPoint)

//       const wPoint = new Decimal(doublePointTag == '2' ? 0.06 : 0.03)
//       addPoint = addPointPrice.times(wPoint)

//       if (saleTag == 'true' && preferentialTag == 'false') {
//         addPoint = new Decimal(0)
//       }

//       if (setPoint) {
//         lineItem[i].innerHTML = Math.sign(addPoint.toNumber()) == 1 ? addPoint.toNumber() : 0
//       }

//       totalAddPoint = totalAddPoint.plus(addPoint)
//     }
//     priceObject.totalAddPoint = totalAddPoint
//     return priceObject
//   }
// }
/**
 * バリエーションの設定に関する制御
 */
ISSEYMIYAKE['ProductOptionSelect'] = {
  init: (evt = false, event = false) => {

    const noneSetVariant = document.querySelectorAll('.none-set-variant')
    const setVariant = document.querySelectorAll('.set-variant')
    const optionInput = document.querySelectorAll('._buttons .on .product_options_input')
    const colorSelect = document.querySelector('._color ._select')
    const colorFirstText = document.querySelector('._color .first_text')
    const sizeSelect = document.querySelector('._size ._select')
    const sizeFirstText = document.querySelector('._size .first_text')

    const params = new URLSearchParams(location.search)
    const isGiftCardOptions = Boolean(document.querySelector('[data-gift-card-options]'))
    if (params.get('variant') || evt === true) {
      if (event?.target?.getAttribute('name') === 'Size' || event?.target?.getAttribute('name') === 'サイズ') {
        ISSEYMIYAKE['ProductOptionSelect'].setVariantSetting(setVariant, noneSetVariant, optionInput, sizeSelect, event.target.value)
        sizeFirstText?.classList.add('hidden')
      } else if (event?.target?.getAttribute('name') === 'Color' || event?.target?.getAttribute('name') === 'カラー') {
        ISSEYMIYAKE['ProductOptionSelect'].setVariantSetting(setVariant, noneSetVariant, optionInput, colorSelect)
        colorFirstText?.classList.add('hidden')
        sizeFirstText?.classList.remove('hidden')
        ISSEYMIYAKE['ProductOptionSelect'].checkOption2Value(event.target.value, sizeSelect, sizeFirstText)
      } else if (isGiftCardOptions && event?.target) {
        const selectedValue = event.target.dataset?.id || event.target.value
        ISSEYMIYAKE['ProductOptionSelect'].setVariantSetting(setVariant, noneSetVariant, optionInput, colorSelect, selectedValue)
        colorFirstText?.classList.add('hidden')
        if (colorFirstText) colorFirstText.style.display = 'none'
      } else {
        ISSEYMIYAKE['ProductOptionSelect'].setVariantSetting(setVariant, noneSetVariant, optionInput, colorSelect)
      }
    } else {
      ISSEYMIYAKE['ProductOptionSelect'].noneSetVariantSetting( colorFirstText, sizeFirstText, setVariant, noneSetVariant, colorSelect, sizeSelect)
    }
  },
  /**
   * バリエーションが設定された場合
   * @param {*} setVariant 
   * @param {*} noneSetVariant 
   * @param {*} optionInput 
   * @param {*} colorSelect 
   */
  setVariantSetting: (setVariant, noneSetVariant, optionInput, select, value = false) => {
    noneSetVariant.forEach((e) => {
      e.classList.add('hidden')
    })
    setVariant.forEach((e) => {
      e.classList.remove('hidden')
    })
    select?.classList.remove('hidden')

    if (value) {
      select.innerHTML = value
    }
    optionInput.forEach(e => {
      if (e?.dataset.id === select?.innerHTML) {
        e.checked = true
      }
    })

  },
  /**
   * バリエーションが選択されている状態の場合の処理
   * @returns 
   */
  hasVariantId(initialVariantId) {
    let variantId = ISSEYMIYAKE['getParams'](['variant'])
    if (!variantId.variant) {
      variantId.variant = initialVariantId
    }
    const colorFirstText = document.querySelector('._color .first_text')
    const sizeFirstText = document.querySelector('._size .first_text')
    const isGiftCardOptions = Boolean(document.querySelector('[data-gift-card-options]'))
    if (!variantId) return false

    if( variantId.variant !== null && !isGiftCardOptions ) {
      sizeFirstText?.classList.add('hidden')
      colorFirstText?.classList.add('hidden')
    }

    const variantData = document.querySelector('#variantData')
    const variants = ISSEYMIYAKE['JSONParse'](variantData?.textContent)
    if (!variants) return false

    const variant = variants.filter(variant => variant.id == Number(variantId.variant))
    if (variant.length === 0) return false
    const colorInput = document.querySelector(`[data-id="${variant[0].option1}"]`)
    if (!colorInput) return false
    const colorPhoto = colorInput.getAttribute('data-photo') || ''
    const sizeOptionDivs = document.querySelectorAll('[data-size-option]')
    const matchedSizeOptionDiv = document.querySelector(`[data-size-option][data-color="${variant[0].option1}"]`)
    if (!isGiftCardOptions) {
      const selectedColorOption = document.querySelector(`[data-selected-color-option]`)
      if (selectedColorOption) selectedColorOption.innerHTML = variant[0].option1
    }
    colorInput.checked = true
    const inStockBtn = document.querySelector('._in_stock.on')
    if (inStockBtn) inStockBtn.disabled = variant[0].available

    if (matchedSizeOptionDiv && sizeOptionDivs.length) {
      sizeOptionDivs.forEach(sizeOptionDiv => {
        sizeOptionDiv.classList.remove('on')
      })
      matchedSizeOptionDiv.classList.add('on')
      const input = matchedSizeOptionDiv.querySelector(`input[data-id="${variant[0].option2}"]`)
      if (input) input.checked = true
    }

    document.addEventListener('gallery:finished-setup', (e) => {
      const gallery = e.detail.gallery

      if (!gallery) return
      const thumbnail = gallery.thumbnail ? [...gallery.thumbnail].find(t => t.id === colorPhoto) : null

      if (thumbnail) {
        thumbnail.click()
      }
    })
  },
  /**
   * option1（カラー）を選択した時にoption2（基本的に"サイズ"）が1種類か確認、1種類の場合自動で選択する
   */
  checkOption2Value(value, sizeSelect, sizeFirstText) {
    const variantData = document.querySelector('#variantData')
    const variants = ISSEYMIYAKE['JSONParse'](variantData?.textContent)
    const variantBisOnCheck = JSON.parse(document.getElementById("variantsOtherData").textContent)
    const submitForm = document.querySelector('#main .products-detail .form')
    const out_of_notification_stock_text = document.querySelector('._out_of_stock_notification_text')
    const arrival_notification = document.querySelector('._arrival_notification')
    const out_of_stock = document.querySelector('._out_of_stock');
    const out_of_stock_text = document.querySelector('._out_of_stock_text');
    const photo = document.querySelectorAll('.f-enlargedImageOpen img');
    var optAllArr = []
    var optAllArr2 = []

    for( let i = 0; variants.length > i; i++){
      var optArr = {}
      optArr.id = variants[i].id;
      optArr.name = variants[i].name;
      if(variants[i].featured_image === null){
        optArr.image = photo[0].src;
      }else{
        optArr.image = variants[i].featured_image.src;
      }
      optArr.available = variants[i].available;
      optArr.option = variants[i].option2;
      optAllArr.push(optArr)
    }
    for( let j = 0; variantBisOnCheck.length > j; j++){
      var opt2Arr = {}
      opt2Arr.id = variantBisOnCheck[j].id;
      opt2Arr.is_can_restock = variantBisOnCheck[j].is_can_restock;
      optAllArr2.push(opt2Arr)
    }
    const optFinalArr = []
    for (let i = 0; i < optAllArr.length; i++) {
      const index = optAllArr2.findIndex(obj => obj.id === optAllArr[i].id);
      if (index !== -1) {
        optFinalArr.push({
          id: optAllArr[i].id,
          name: optAllArr[i].name,
          image: optAllArr[i].image,
          available: optAllArr[i].available,
          option: optAllArr[i].option,
          is_can_restock: optAllArr2[index].is_can_restock
        });
      } else {
        optFinalArr.push(optAllArr[i]);
      }
    }
    if (optFinalArr.every(v => v.option === optFinalArr[0].option)) {
      const targetColor = document.querySelector(`[data-color="${value}"] input`);
      const targetId = targetColor ? targetColor.id : null;
      const targetArrItem = targetId ? optFinalArr.find(item => item.id == targetId) : null;
      const targetBuyBtn = document.querySelector('._in_stock.on');
      sizeFirstText.classList.add('hidden');
      sizeSelect.innerHTML = optFinalArr[0].option;
      const variantId = submitForm.querySelector('input[name="id"]');
      variantId.value = targetId;
      const wishlistBtn = document.querySelector('wish-list-button');
      wishlistBtn.setAttribute('product-variant-id', targetId);
      // const wishlistName = document.querySelector('.swym-details strong');
      // wishlistName.innerHTML = targetArrItem.name;
      const wishlistImg = document.querySelector('.swym-product-tile img');
      wishlistImg.src = targetArrItem.image;

      if (targetArrItem) {
        const targetAvailable = targetArrItem.available;
        const targetItemBIS = targetArrItem.is_can_restock;

        targetColor.checked = true
        targetBuyBtn.classList.remove('hidden');

        if (!targetAvailable) {
          if (targetItemBIS) {
            targetBuyBtn.classList.add('hidden');
            arrival_notification.classList.add('on');
            out_of_notification_stock_text.classList.add('on');
          } else {
            targetBuyBtn.disabled = true;
            out_of_stock.classList.add('add');
            out_of_stock_text.classList.add('add');
          }
        } else {
          targetBuyBtn.disabled = false;
        }
      } else {
        console.log('error');
      }
    }
  },
  /**
   * バリエーションが設定されていない場合
   * @param {*} setVariant 
   * @param {*} noneSetVariant 
   * @param {*} colorSelect 
   */
  noneSetVariantSetting: (colorFirstText, sizeFirstText, setVariant, noneSetVariant, colorSelect, sizeSelect) => {
    const onlyColor = colorFirstText.classList.contains('only_one_color')
    const onlySize = document.querySelector('._button__number')
    const ifOnlySize = onlySize.classList.contains('only_one_option')

    setVariant.forEach((e) => {
      e.classList.add('hidden')
    })
    noneSetVariant.forEach((e) => {
      e.classList.remove('hidden')
    })
    if(onlyColor){
      colorFirstText.classList.add('hidden')
      if(ifOnlySize){
        sizeFirstText.classList.add('hidden')
        sizeSelect.innerHTML = onlySize.innerHTML
        setVariant.forEach((e) => {
          e.classList.remove('hidden')
        })
        noneSetVariant.forEach((e) => {
          e.classList.add('hidden')
        })
      }
    } else {
      colorSelect.classList.add('hidden')
      colorFirstText.classList.remove('hidden')
      sizeFirstText.classList.add('hidden')
    }
  }
}